<div class="w-full h-16 flex justify-center items-center px-4 bg-red-100">
  <p class="text-red-600 font-bold" i18n="@@infoBar_trialExpiredMessage_label">
    Dein kostenloser Testzeitraum ist abgelaufen. Bitte abonniere eines unserer
    Preispakete um KlickLead weiter nutzen zu können.
  </p>
</div>
